export const FETCH_POLICIES = "FETCH_POLICIES";
export const CREATE_POLICY = "CREATE_POLICY";
export const UPDATE_POLICY = "UPDATE_POLICY";
export const DELETE_POLICY = "DELETE_POLICY";
export const INVITE_USER = "INVITE_USER";
export const ASSIGN_POLICY_TO_GROUP = "ASSIGN_POLICY_TO_GROUP";
